// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sector-box[data-v-29d35926]{border-bottom:1px solid #eaeaea;cursor:pointer}.cursor-default[data-v-29d35926]{cursor:default!important}", ""]);
// Exports
module.exports = exports;
